// A18.03 — PII kirish jurnali adapter. Module-local (shared adapters.ts ga
// tegmaydi). Superadmin-only endpointlar; oddiy xodimga 403 qaytadi.
import { api } from '@/lib/api'

export interface PIIAccessRow {
  id?: number
  admin?: string | null
  action: string
  category: string
  target?: string | null
  detail?: string | null
  ip?: string | null
  created_at: number
}

export interface PIIAccessQuery {
  admin?: string
  category?: string
  subject?: string
  since?: number
  until?: number
  limit?: number
}

export async function searchPIIAccess(q: PIIAccessQuery): Promise<PIIAccessRow[]> {
  const r = await api.get<{ items?: PIIAccessRow[] }>('/admin/audit/pii', {
    query: {
      admin: q.admin || undefined,
      category: q.category || undefined,
      subject: q.subject || undefined,
      since: q.since || undefined,
      until: q.until || undefined,
      limit: q.limit ?? 300,
    },
  })
  return r.items ?? []
}

export async function fetchPIICategories(): Promise<string[]> {
  const r = await api.get<{ items?: string[] }>('/admin/audit/pii/categories')
  return r.items ?? []
}
